import { SITE_LOGIN_URL } from 'config/constants'

export default function loginRedirect () {
  window.location = SITE_LOGIN_URL + '?goto=' + encodeURI(window.location.href)
}
